import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
  width: 100%;

  position: relative;
`;

export const Banner = styled.div`
  position: relative;
  width: 100%;
  height: 700px;
  overflow: hidden;
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  // height: 100%;
`;

export const BannerImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  object-fit: cover;
  opacity: ${({ $active }) => ($active ? 0.8 : 0)};
  transition: opacity 1s ease-in-out;
  z-index: ${({ $active }) => ($active ? 1 : 0)};
`;

export const Logo = styled.img`
  position: absolute;

  top: 45%;
  left: 8%;

  width: 580px;
  height: 180px;

  object-fit: contain;
  opacity: 1;
  z-index: 10;

  ${media.lessThan("medium")`
    width: 60%;
  `}
`;

export const Boxes = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;

  position: absolute;
  bottom: 0px;
  left: 0;

  ${media.lessThan("medium")`
    bottom: 0px;

    overflow-x: auto;
    gap: 20px;
    max-width: 100%;

    justify-content: flex-start;
  `}
`;

export const Box = styled.div`
  position: relative;
  width: 312px;
  height: 170px;

  span {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};

    z-index: 3;
    max-width: 200px;

    position: absolute;
    bottom: 20px;
    left: 20px;
  }

  img {
    width: 312px;
    height: 170px;
    object-fit: cover;

    position: absolute;
    top: 0;
    left: 0;

    z-index: 1;
  }

  ${media.lessThan("medium")`
    min-width: 160px;
    height: 100px;

    img {
      width: 160px;
      height: 100px;
    }

    span {
      font-size: 14px;
      bottom: 10px;
      left: 10px;
    }
  `}
`;

export const BoxBg = styled.div`
  width: 312px;
  background-color: ${({ color }) => color};
  height: 170px;
  object-fit: contain;

  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  transition: opacity 0.3s;

  opacity: ${({ $active }) => ($active ? "0.8" : 1)};

  :hover {
    opacity: 0.9;
  }

  ${media.lessThan("medium")`
    width: 160px;
    height: 100px;
  `}
`;

export const Main = styled.div`
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 80px 0px;
`;

export const MainContent = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;

  img {
    width: 482px;
    height: 290px;

    object-fit: cover;
    object-position: center center;

    ${media.lessThan("medium")`
      width: 312px;
      height: 170px;
    `}
  }

  ${media.lessThan("medium")`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 40px;
    padding: 0 24px;
  `}
`;

export const CarouselWrapper = styled.div`
  position: relative;
  width: 482px;
  height: 290px;

  ${media.lessThan("medium")`
    width: 312px;
    height: 170px;
  `}
`;

export const CarouselImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 482px !important;
  height: 290px !important;
  object-fit: cover;
  object-position: top center;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity 1s ease-in-out;
  z-index: ${({ $active }) => ($active ? 1 : 0)};

  ${media.lessThan("medium")`
    width: 312px !important;
    height: 170px !important;
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  h2 {
    font-size: 32px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;

  ${media.lessThan("medium")`
    flex-direction: column;
    gap: 20px;
  `}

  a {
    display: flex;
    text-decoration: none;
    width: 48%;

    button {
      width: 100%;
    }

    ${media.lessThan("medium")`
      width: 100%;
    `}
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 12px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

  ${media.lessThan("medium")`
    padding: 30px 20px;
  `}
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;

  h3 {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.neutral.cinza800};
    margin-bottom: 12px;
  }

  p {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.neutral.cinza600};
    line-height: 1.5;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;

  ${media.lessThan("medium")`
    gap: 10px;
  `}
`;

export const ModalForgotPassword = styled.button`
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.primary.vividCerulean};
  cursor: pointer;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;
